import type { RelationshipLens } from '../data/graph-types.js';
import type { GraphIndex, GraphPath } from './graph.js';
import { serializeAtlasUrlState } from './url-state.js';

export type TraceShareDetails = {
  title: string;
  text: string;
  url: string;
};

export const CANONICAL_SITE_ORIGIN = 'https://entangledvega.com';

export function canonicalTraceUrl(
  origin: string,
  from: string,
  to: string,
  lenses: readonly RelationshipLens[],
  storyId: string | null = null,
): string {
  const url = new URL('/', origin);
  url.search = serializeAtlasUrlState({
    personId: null,
    traceFrom: from,
    traceTo: to,
    storyId,
    view: 'graph',
    lenses,
  });
  return url.href;
}

export function traceShareDetails(
  origin: string,
  from: string,
  to: string,
  lenses: readonly RelationshipLens[],
  path: GraphPath,
  index: GraphIndex,
  storyId: string | null = null,
): TraceShareDetails {
  const fromName = index.peopleById.get(from)?.name ?? from;
  const toName = index.peopleById.get(to)?.name ?? to;
  const steps = path.relationships.length;
  return {
    title: `${fromName} to ${toName} — Entangled Vega`,
    text: `${fromName} connects to ${toName} in ${steps} source-linked ${steps === 1 ? 'step' : 'steps'} on Entangled Vega.`,
    url: canonicalTraceUrl(origin, from, to, lenses, storyId),
  };
}
